import {
  doiDefinition,
  issnDefinition,
  isbnDefinition,
  landingPageUrlDefinition,
  similarityCheckUrlDefinition,
  publisherDefinition,
  referencesDefinition,
  languageCodesDefinition,
  contributorDefinition,
  contributorsDefinition,
  abstractsDefinition,
  publicationDatesDefinition,
} from '../common/common-schemas';

const commonDefinitions = {
  abstracts: abstractsDefinition,
  contributor: contributorDefinition,
  contributors: contributorsDefinition,
  doi: doiDefinition,
  isbn: isbnDefinition,
  'crossref_language_codes': languageCodesDefinition,
  issn: issnDefinition,
  landingPageUrl: landingPageUrlDefinition,
  publicationDates: publicationDatesDefinition,
  publisher: publisherDefinition,
  references: referencesDefinition,
  similarityCheckUrl: similarityCheckUrlDefinition,
};

export const conferenceProceedingSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Conference Proceeding Metadata',
  type: 'object',
  required: [
    'conferenceName',
    'proceedingsTitle',
    'doi',
    'landingPageUrl',
    'publisher',
    'publicationDates',
  ],
  properties: {
    conferenceName: {
      type: 'string',
      i18n: 'conferenceProceeding_conferenceName',
    },
    conferenceAcronym: {
      type: 'string',
      i18n: 'conferenceProceeding_conferenceAcronym',
    },
    proceedingsTitle: {
      type: 'string',
      i18n: 'conferenceProceeding_proceedingsTitle',
    },
    doi: {
      $ref: '#/definitions/doi',
    },
    landingPageUrl: {
      $ref: '#/definitions/landingPageUrl',
    },
    publisher: {
      $ref: '#/definitions/publisher',
    },
    publicationDates: {
      $ref: '#/definitions/publicationDates',
    },
    isbn: {
      $ref: '#/definitions/isbn',
    },
  },
  definitions: {
    ...commonDefinitions,
  },
};

export const conferencePapersSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Conference Papers Metadata',
  type: 'object',
  properties: {
    conferencePapers: {
      type: 'array',
      items: {
        $ref: '#/definitions/conferencePaper',
      },
    },
  },
  definitions: {
    ...commonDefinitions,
    conferencePaper: {
      type: 'object',
      required: [
        'paperTitle',
        'doi',
        'landingPageUrl',
        'contributors',
        'publicationDates',
      ],
      properties: {
        paperTitle: {
          type: 'string',
        },
        doi: {
          $ref: '#/definitions/doi',
        },
        landingPageUrl: {
          $ref: '#/definitions/landingPageUrl',
        },
        contributors: {
          $ref: '#/definitions/contributors',
        },
        abstracts: {
          $ref: '#/definitions/abstracts',
        },
        publicationDates: {
          $ref: '#/definitions/publicationDates',
        },
        similarityCheckUrl: {
          $ref: '#/definitions/similarityCheckUrl',
        },
        pageOrArticleNumber: {
          type: 'object',
          i18n: 'contentRegistrationForm_article_pageOrArticleNumber',
          properties: {
            firstPageNumber: {
              type: 'string',
              pattern: '^[0-9a-zA-Z]+$',
            },
            articleNumber: {
              type: 'string',
            },
          },
        },
        references: {
          $ref: '#/definitions/references',
        },
      },
    },
  },
};

export const conferenceSeriesSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Conference Series Metadata',
  type: 'object',
  required: ['seriesTitle', 'issn'],
  properties: {
    seriesTitle: {
      type: 'string',
    },
    issn: {
      $ref: '#/definitions/issn',
    },
  },
  definitions: {
    ...commonDefinitions,
  },
};

export const conferenceProceedingRecordSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Conference Proceeding',
  type: 'object',
  required: ['proceedingMetadata'],
  properties: {
    proceedingMetadata: conferenceProceedingSchema,
    papers: {
      type: 'array',
      items: {
        $ref: '#/definitions/conferencePaper',
      },
    },
    series: conferenceSeriesSchema,
  },
  definitions: {
    ...commonDefinitions,
    conferencePaper: conferencePapersSchema.definitions.conferencePaper,
  },
};
